import { create } from 'zustand';
import { FileSearchStatus, FileSearchIndexProgress } from '../../../types';
import type { InitTimingReport } from '../api/WebRTCSystem';

interface FileSearchStatusStore {
  status: FileSearchStatus;
  progress: FileSearchIndexProgress | null;
  initTiming: InitTimingReport | null;
  isInitTimingPanelOpen: boolean;
  isInitTimingSummaryHidden: boolean;  // 用户主动 X 关闭后置 true, 直到下次 init 重新出现
  updateStatus: (progress: FileSearchIndexProgress) => void;
  syncFromBackend: (backendStatus: string) => void;
  setInitTiming: (r: InitTimingReport | null) => void;
  openInitTimingPanel: () => void;
  closeInitTimingPanel: () => void;
  dismissInitTimingSummary: () => void;
  reset: () => void;
}

// Map backend status string to frontend enum
const mapBackendStatus = (backendStatus: string): FileSearchStatus => {
  switch (backendStatus) {
    case 'ready':
      return FileSearchStatus.READY;
    case 'initializing':
    case 'indexing':
      return FileSearchStatus.INDEXING;
    case 'building_index':
      return FileSearchStatus.BUILDING_INDEX;
    case 'calculating_sizes':
      return FileSearchStatus.CALCULATING_SIZES;
    case 'error':
    case 'not_started':
    default:
      return FileSearchStatus.UNINITIALIZED;
  }
};

export const useFileSearchStatusStore = create<FileSearchStatusStore>((set) => ({
  status: FileSearchStatus.UNINITIALIZED,
  progress: null,
  initTiming: null,
  isInitTimingPanelOpen: false,
  isInitTimingSummaryHidden: false,

  updateStatus: (progress: FileSearchIndexProgress) => {
    console.log('[FileSearchStatus] Status update:', progress);
    set({ status: progress.status, progress });
  },

  // Sync status from backend (called on page load)
  syncFromBackend: (backendStatus: string) => {
    const mappedStatus = mapBackendStatus(backendStatus);
    console.log('[FileSearchStatus] Sync from backend:', backendStatus, '->', mappedStatus);
    set({ status: mappedStatus });
  },

  // setInitTiming: 新报告到来时自动重置 hidden 标志, 让用户主动关闭后下次 init 仍能看到
  setInitTiming: (r) => set({ initTiming: r, isInitTimingSummaryHidden: false }),
  openInitTimingPanel: () => set({ isInitTimingPanelOpen: true }),
  closeInitTimingPanel: () => set({ isInitTimingPanelOpen: false }),
  dismissInitTimingSummary: () => set({ isInitTimingSummaryHidden: true }),

  reset: () => {
    set({ status: FileSearchStatus.UNINITIALIZED, progress: null, initTiming: null, isInitTimingSummaryHidden: false });
  },
}));
